var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3752 16.1875H10.3335C9.80391 16.1875 9.36475 15.7625 9.36475 15.25C9.36475 14.7375 9.80391 14.3125 10.3335 14.3125H19.3752C19.9047 14.3125 20.3439 14.7375 20.3439 15.25C20.3439 15.7625 19.9047 16.1875 19.3752 16.1875Z",
    fill: "#B3B9CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.991 21.1875H10.3335C9.80391 21.1875 9.36475 20.7625 9.36475 20.25C9.36475 19.7375 9.80391 19.3125 10.3335 19.3125H15.991C16.5206 19.3125 16.9597 19.7375 16.9597 20.25C16.9597 20.7625 16.5206 21.1875 15.991 21.1875Z",
    fill: "#B3B9CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0835 8.4375H12.9168C11.6768 8.4375 9.36475 8.4375 9.36475 5C9.36475 1.5625 11.6768 1.5625 12.9168 1.5625H18.0835C19.3235 1.5625 21.6356 1.5625 21.6356 5C21.6356 6.2 21.6356 8.4375 18.0835 8.4375ZM12.9168 3.4375C11.6381 3.4375 11.3022 3.4375 11.3022 5C11.3022 6.5625 11.6381 6.5625 12.9168 6.5625H18.0835C19.6981 6.5625 19.6981 6.2375 19.6981 5C19.6981 3.4375 19.3622 3.4375 18.0835 3.4375H12.9168Z",
    fill: "#B3B9CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 28.4375H11.625C4.36583 28.4375 2.90625 25.2125 2.90625 20V12.5C2.90625 6.80004 5.0375 4.36254 10.2817 4.10004C10.7983 4.07504 11.2762 4.46254 11.3021 4.98754C11.3279 5.51254 10.9146 5.93754 10.385 5.96254C6.71667 6.16254 4.84375 7.22504 4.84375 12.5V20C4.84375 24.625 5.78667 26.5625 11.625 26.5625H19.375C25.2133 26.5625 26.1562 24.625 26.1562 20V12.5C26.1562 7.22504 24.2833 6.16254 20.615 5.96254C20.0854 5.93754 19.6721 5.48754 19.6979 4.97504C19.7237 4.46254 20.1888 4.06254 20.7183 4.08754C25.9625 4.36254 28.0938 6.80004 28.0938 12.4875V19.9875C28.0938 25.2125 26.6342 28.4375 19.375 28.4375Z",
    fill: "#B3B9CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProposal);
export default __webpack_public_path__ + "static/media/all-proposal.8424ba9249efec2e132abae7df5cb4c7.svg";
export { ForwardRef as ReactComponent };